import { useCheckFeature } from "@/composables/useCheckFeature";
import { storeToRefs } from "pinia";
import { useAuth } from "@/stores/AuthStore";

export const benefitsAdminGuard = async (to, from, next) => {
    const { organization } = storeToRefs(useAuth());
    const { loadMemberFeatures, canAccessBenefitDefinitions } = useCheckFeature();

    await loadMemberFeatures(organization.value.slug);

    if (canAccessBenefitDefinitions.value) {
        return next();
    }

    return next("");
};
